import React from 'react'
import ExportExcel from './ExportExcel'

function Excel() {
  return (
    <div>
        <ExportExcel/>
    </div>
  )
}

export default Excel